/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";

import { constantSemanticColors, shades } from "../../../../../global/emotion";
import { useIsDesktopViewport } from "../../../../hooks/useIsDesktopViewport";
import { CheckmarkIcon } from "../../icons/Icon/GeneralIcons";

const overlayStyle: Interpolation = {
  background: shades.shade40,
  display: "flex",
  inset: 0,
  placeContent: "center",
  placeItems: "center",
  position: "absolute",
  zIndex: 2,
};

type AssignmentCompletedOverlayProps = {
  size: "s" | "l";
};

export const AssignmentCompletedOverlay = ({
  size,
}: AssignmentCompletedOverlayProps) => {
  const isDesktop = useIsDesktopViewport();

  return (
    <div css={overlayStyle}>
      <CheckmarkIcon.FilledOn
        color={constantSemanticColors.onColorHighest}
        size={size === "l" || isDesktop ? 32 : 20}
      />
    </div>
  );
};
